import font from "@/config/font.js";

export default {
  data() {
    return {
      fontScale: 'm', // Default font scale, defaults to 'm' (medium)
      fontSize: '' // Actual font size, initially an empty string
    };
  },
  created() {
    // Executes when the component is created, retrieves the font scale from localStorage
    const saved = localStorage.getItem('fontScale');

    if (saved) {
      this.fontScale = saved; // Sets the font scale to the value saved in localStorage
    }

    // Checks if the font scale retrieved from localStorage is valid
    if (Object.keys(font.sizes).includes(this.fontScale)) {
      this.fontSize = font.sizes[this.fontScale]; // Retrieves the font size
    } else {
      // Handles the old font size save logic, as previously it saved pixel values instead of font scale
      this.migrateFontSize();
    }
  },
  methods: {
    migrateFontSize() {
      // Retrieves the old font size definitions (e.g., "s": "12px", "m": "16px")
      const oldSizes = {
        "s": "12px",
        "m": "16px",
        "l": "20px"
      };

      let key = font.defaultScale;

      // Finds the old font size definition where the value matches this.fontScale
      const entry = Object.entries(oldSizes).find(size => size[1] === this.fontScale) ?? 
              Object.entries(font.sizes).find(size => size[1] === this.fontScale);
      
      if (entry) [key] = entry;
      
      // Updates this.fontScale to the matching font scale
      this.fontScale = key;

      // Retrieves the font size corresponding to the new font scale
      this.fontSize = font.sizes[key];

      // Saves the new font scale to localStorage
      localStorage.setItem('fontScale', this.fontScale);
    },

    updateFontScale(scale) {
      this.fontScale = scale;
      localStorage.setItem('fontScale', scale);
    }
  }
};
